import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerStatementsReport extends Layout {
    checkboxEmailStatement: Checkbox;
    checkboxIncludeOpenBalance: Checkbox;
    checkboxPayableContact: Checkbox;
    excludabletextboxCategory: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    sourceCustomerStatement: DataSource;
    switchSortBy: Switch;
    textboxAgeDate: Textbox;
    textboxCutoffBillDate: Textbox;
    textboxEmailProfile: Textbox;
    textboxEmailRecipient: Textbox;
}
